import { useEffect } from 'react';
import { XCircle } from 'lucide-react';

export default function Failure() {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.close();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-red-50">
      <div className="text-center animate-fade-in">
        <div className="flex justify-center mb-4">
          <XCircle className="w-12 h-12 text-red-600 animate-bounce" />
        </div>
        <h1 className="text-2xl font-bold text-red-600 mb-2" role="alert">
          Authentication Failed
        </h1>
        <p className="text-gray-600">
          Please try again.
          <span className="inline-block ml-1 animate-pulse">⌛</span>
        </p>
      </div>
    </div>
  );
}
